import {Tabs} from './tabs';

let tabs;

const initTab = () => {
  tabs = new Tabs();
  // Используйте в разработке экспортируемую переменную tabs, window сделан для бэкэнда
  window.tabs = tabs;
};

export {initTab, tabs};
